import { Button } from '../Button'
import advantages from '../../data/advantages'
import './Advantages.scss'

export const Advantages = () => {
    return (
        <div className='advantages'>
            <div className="container">
                <h3 className="advantages_title">Преимущества нашей <strong>вебкам-студии</strong></h3>

                <p className="advantages_text">
                    Устала от злободневных финансовых потребностей?
                    Хочешь ставить перед собой долгосрочные цели?
                    Наша вебкам-студия предоставляет все условия и дает возможность получить обеспеченную жизнь, карьерный рост, стабильный доход.
                </p>
                <div className='items_advantages'>
                    {
                        advantages.map((item, index) => <div key={index} className='item_advantage'>
                            <div className="image_advantage">
                                <img src={`../images/${item.img}`} alt={item.alt} />
                            </div>
                            <h3 className="item_title_advantage">{item.title}</h3>
                            <div className="text_item_advantage">
                                {item.text}
                            </div>
                        </div>)
                    }
                </div>
                <Button>
                    <a href={'#contacts'} className=''>
                        <button className='theme_button'>отправить заявку</button>
                    </a>
                </Button>
            </div>
        </div>
    )
}